
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import { countryNoComList, parseTime } from "@/utils";
import Pagination from "@/comp/Pagination/index.vue";
import { systemNoticeList, systemNoticeSave, systemNoticeRemove } from "@/api/request/bulletin";

//组件
@Component({
  name: "SystemNotice",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private countryList: any[] = [];
  private listLoading: boolean = false;

  //列表请求参数
  private listQuery: any = {
    //页面数据
    page: 1,
    page_size: 20,

    //请求数据
    type: 0, //类型
    title: "", //标题
    belong: "", //归属地区
  };

  //类型列表
  private typeList: any[] = [
    { type: 0, name: "全部" },
    { type: 1, name: "博主端" },
    { type: 2, name: "用户端" },
  ];

  //类型列表
  private statusList: any[] = [
    { status: 0, name: "禁用" },
    { status: 1, name: "启用" },
  ];

  //创建
  created() {
    //数据赋值
    this.countryList = countryNoComList;

    //获取列表
    this.getList();
  }

  //获取列表
  private async getList() {
    //显示等待
    this.listLoading = true;

    //获取数据
    const { data } = await systemNoticeList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //处理添加
  private handleAdd(): void {
    //数据赋值
    this.form = {
      //临时变量
      time: [], //时间
      sort_str: "", //排序

      //变量
      id: 0, //ID
      type: 0, //类型
      sort: 1, //排序
      title: "", //标题
      status: 1, //状态
      belong: "", //所属地区
      end_time: 0, //结束时间
      begin_time: 0, //开始时间

      //内容
      lang_list: {
        zh: "",
        tw: "",
        en: "",
        id: "",
      },
    };
    this.belong = [];

    //显示界面
    this.dialogVisible = true;
    this.dialogTitle = "添加系统公告";
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取列表
    this.getList();
  }

  //处理编辑
  private handleEdit(row: any): void {
    //数据赋值
    this.form = {
      //临时变量
      sort_str: String(row.sort), //排序
      time: [this.handleTime(row.begin_time * 1000), this.handleTime(row.end_time * 1000)], //时间

      //变量
      id: row.id, //ID
      type: row.type, //类型
      sort: row.sort, //排序
      title: row.title, //标题
      status: row.status, //状态
      belong: row.belong, //所属地区
      end_time: row.end_time, //结束时间
      begin_time: row.begin_time, //开始时间

      //内容
      lang_list: {
        zh: row.lang_list.zh ? row.lang_list.zh : "",
        tw: row.lang_list.tw ? row.lang_list.tw : "",
        en: row.lang_list.en ? row.lang_list.en : "",
        id: row.lang_list.id ? row.lang_list.id : "",
      },
    };
    this.belong = String(row.belong).split(",");

    //显示界面
    this.dialogVisible = true;
    this.dialogTitle = "编辑系统公告";
  }

  //处理删除
  private handleDelete(row: any): void {
    this.$confirm(`您确定要删除系统公告？`, "警告", {
      type: "warning",
      cancelButtonText: this.$t("permission.cancel") as string,
      confirmButtonText: this.$t("permission.confirm") as string,
    })
      .then(async () => {
        //删除公告
        await systemNoticeRemove({ id: row.id });

        //显示提示
        this.$message.success("删除成功");

        //获取列表
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //处理时间
  private handleTime(time: number): string {
    //返回时间
    return parseTime(time, "{y}-{m}-{d} {h}:{i}:{s}") as string;
  }

  //---------------------------- 发送消息 ----------------------------
  //定义变量
  private belong: any[] = [];
  private dialogTitle: string = "";
  private dialogVisible: boolean = false;
  private dialogLoading: boolean = false;

  //表单数据
  private form: any = {
    //临时变量
    time: [], //时间
    sort_str: "", //排序

    //变量
    id: 0, //ID
    type: 0, //类型
    sort: 1, //排序
    title: "", // 标题
    status: 1, //状态
    belong: "", //所属地区
    end_time: 0, //结束时间
    begin_time: 0, //开始时间

    //内容
    lang_list: {
      zh: "",
      tw: "",
      en: "",
      id: "",
    },
  };

  //归属地区
  private countrySelect: any[] = [
    { country: "", name: "请选择归属地区" },
    { country: "MY", name: "MY" },
    { country: "ID", name: "ID" },
    { country: "TW", name: "TW" },
  ];

  //取消按钮
  private btnCancel(): void {
    //隐藏界面
    this.dialogVisible = false;
  }

  //保存按钮
  private async btneSave() {
    //判断返回
    if (this.form.time.length == 0) return this.$message.error("请选择公告时间！");
    if (Number(this.form.sort_str) == 0) return this.$message.error("请输入排序！");
    if (this.form.title == "") return this.$message.error("请输入标题！");
    if (this.belong.length == 0) return this.$message.error("请选择所属地区！");
    if (this.form.lang_list.zh == "") return this.$message.error("请输入公告内容(中文)");

    //数据赋值
    this.form.belong = String(this.belong);
    this.form.sort = Number(this.form.sort_str);
    this.form.end_time = Math.floor(new Date(this.form.time[1]).getTime() / 1000);
    this.form.begin_time = Math.floor(new Date(this.form.time[0]).getTime() / 1000);

    //显示等待
    this.dialogLoading = true;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 5 * 1000);

    //添加活动
    await systemNoticeSave(this.form);

    //显示提示
    this.$notify({ title: "成功", message: this.dialogTitle + "成功", type: "success", duration: 2000 });

    //隐藏界面
    this.dialogLoading = false;
    this.dialogVisible = false;

    //重新获取数据
    this.getList();
  }
}
